var _tspan, _tspan2, _tspan3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlpacaMs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 336.42 158.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M113.63,35.67c-2.84,0-5.16,.36-6.93,1.07-1.78,.71-3,1.37-3.66,1.98-.36-.25-.67-.61-.95-1.07-.28-.46-.42-.96-.42-1.52s.14-1.04,.42-1.45c.28-.41,.62-.76,1.03-1.07,.51-.41,1.63-.86,3.35-1.37,1.73-.51,4.06-.76,7.01-.76,6.04,0,10.74,1.25,14.09,3.73,3.35,2.49,5.03,6.5,5.03,12.04v22.78c-1.47,.25-3.59,.52-6.36,.8-2.77,.28-5.9,.42-9.41,.42-4.06,0-7.33-.36-9.79-1.07s-4.38-1.64-5.75-2.78c-1.37-1.14-2.29-2.42-2.74-3.85-.46-1.42-.68-2.84-.68-4.27,0-1.83,.28-3.49,.84-4.99,.56-1.5,1.51-2.78,2.86-3.85,1.35-1.07,3.16-1.9,5.45-2.52,2.29-.61,5.15-.91,8.61-.91,1.12,0,2.29,.04,3.5,.11,1.22,.08,2.37,.15,3.47,.23,1.09,.08,2.08,.17,2.97,.27,.89,.1,1.59,.18,2.1,.23v-.46c0-2.34-.39-4.27-1.18-5.79-.79-1.52-1.83-2.73-3.12-3.62-1.29-.89-2.78-1.5-4.46-1.83s-3.43-.5-5.26-.5Zm14.02,16.46c-.46-.1-1.66-.3-3.62-.61-1.96-.3-4.84-.46-8.65-.46-1.88,0-3.58,.13-5.1,.38-1.52,.26-2.83,.7-3.92,1.33-1.09,.64-1.93,1.49-2.51,2.55-.58,1.07-.88,2.39-.88,3.96,0,2.74,1.08,4.76,3.24,6.06,2.16,1.29,5.75,1.94,10.78,1.94,3.3,0,5.76-.14,7.39-.42,1.62-.28,2.72-.5,3.28-.65v-14.09Z",
    style: {
      fill: "#010101",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.23,16.63c0-.76,.22-1.38,.65-1.87,.43-.48,1.13-.72,2.1-.72,.46,0,.9,.06,1.33,.19s.75,.24,.95,.34v55.62h-5.03V16.63Z",
    style: {
      fill: "#010101",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.98,53.19c0-1.22,.04-2.3,.11-3.24,.08-.94,.16-1.76,.27-2.48,.46-2.49,1.24-4.72,2.36-6.7,1.12-1.98,2.52-3.66,4.19-5.03,1.68-1.37,3.61-2.42,5.79-3.16,2.18-.74,4.54-1.11,7.08-1.11,2.94,0,5.66,.52,8.15,1.56,2.49,1.04,4.62,2.47,6.4,4.27,1.78,1.8,3.16,3.91,4.15,6.32,.99,2.41,1.49,4.99,1.49,7.73s-.5,5.4-1.49,7.81c-.99,2.41-2.38,4.52-4.15,6.32-1.78,1.8-3.91,3.21-6.4,4.23-2.49,1.02-5.21,1.52-8.15,1.52-3.25,0-6.17-.67-8.76-2.02-2.59-1.35-4.6-3.11-6.02-5.3v21.48h-5.03V53.19Zm34.59-1.83c0-2.13-.34-4.15-1.03-6.06-.69-1.9-1.68-3.56-2.97-4.95-1.29-1.4-2.84-2.5-4.65-3.32-1.8-.81-3.85-1.22-6.13-1.22s-4.25,.39-6.06,1.18c-1.8,.79-3.34,1.87-4.61,3.24-1.27,1.37-2.26,3.01-2.97,4.91-.71,1.9-1.07,3.97-1.07,6.21s.35,4.15,1.07,6.06c.71,1.9,1.71,3.56,3.01,4.95,1.3,1.4,2.84,2.51,4.65,3.35,1.8,.84,3.8,1.26,5.98,1.26s4.33-.39,6.13-1.18c1.8-.79,3.35-1.89,4.65-3.31,1.3-1.42,2.29-3.07,2.97-4.95,.68-1.88,1.03-3.94,1.03-6.17Z",
    style: {
      fill: "#010101",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.58,35.67c-2.84,0-5.16,.36-6.93,1.07-1.78,.71-3,1.37-3.66,1.98-.36-.25-.67-.61-.95-1.07-.28-.46-.42-.96-.42-1.52s.14-1.04,.42-1.45c.28-.41,.62-.76,1.03-1.07,.51-.41,1.63-.86,3.35-1.37,1.73-.51,4.06-.76,7.01-.76,6.04,0,10.74,1.25,14.09,3.73,3.35,2.49,5.03,6.5,5.03,12.04v22.78c-1.47,.25-3.59,.52-6.36,.8-2.77,.28-5.9,.42-9.41,.42-4.06,0-7.33-.36-9.79-1.07-2.46-.71-4.38-1.64-5.75-2.78s-2.29-2.42-2.74-3.85c-.46-1.42-.68-2.84-.68-4.27,0-1.83,.28-3.49,.84-4.99s1.51-2.78,2.86-3.85c1.35-1.07,3.16-1.9,5.45-2.52,2.29-.61,5.15-.91,8.61-.91,1.12,0,2.29,.04,3.5,.11,1.22,.08,2.37,.15,3.47,.23,1.09,.08,2.08,.17,2.97,.27,.89,.1,1.59,.18,2.1,.23v-.46c0-2.34-.39-4.27-1.18-5.79-.79-1.52-1.83-2.73-3.12-3.62-1.29-.89-2.78-1.5-4.46-1.83s-3.43-.5-5.26-.5Zm14.02,16.46c-.46-.1-1.66-.3-3.62-.61-1.96-.3-4.84-.46-8.65-.46-1.88,0-3.58,.13-5.1,.38-1.52,.26-2.83,.7-3.92,1.33-1.09,.64-1.93,1.49-2.51,2.55-.58,1.07-.88,2.39-.88,3.96,0,2.74,1.08,4.76,3.24,6.06,2.16,1.29,5.75,1.94,10.78,1.94,3.3,0,5.76-.14,7.39-.42,1.62-.28,2.72-.5,3.28-.65v-14.09Z",
    style: {
      fill: "#010101",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.47,35.82c-2.13,0-4.1,.3-5.9,.91-1.8,.61-3.37,1.55-4.69,2.82-1.32,1.27-2.35,2.88-3.09,4.84-.74,1.95-1.11,4.25-1.11,6.89s.41,5.1,1.22,7.08c.81,1.98,1.92,3.59,3.31,4.84,1.4,1.25,3.05,2.17,4.95,2.78s3.92,.91,6.06,.91c2.69,0,4.78-.31,6.29-.91,1.5-.61,2.65-1.14,3.47-1.6l2.06,3.73c-1.48,.81-3.17,1.54-5.1,2.17-1.93,.63-4.47,.95-7.62,.95-2.85,0-5.5-.43-7.96-1.3-2.46-.86-4.58-2.13-6.36-3.81-1.78-1.68-3.17-3.73-4.19-6.17-1.02-2.44-1.52-5.21-1.52-8.3s.51-6.06,1.52-8.57c1.02-2.51,2.41-4.63,4.19-6.36,1.78-1.73,3.91-3.03,6.4-3.92,2.49-.89,5.21-1.33,8.15-1.33,3.35,0,5.97,.34,7.85,1.03,1.88,.68,3.05,1.23,3.51,1.64,.35,.26,.66,.57,.91,.95s.38,.85,.38,1.41c0,.41-.14,.89-.42,1.45-.28,.56-.7,1.04-1.26,1.45-.86-.76-2.22-1.55-4.08-2.36-1.85-.81-4.18-1.22-6.97-1.22Z",
    style: {
      fill: "#010101",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.27,35.67c-2.84,0-5.16,.36-6.93,1.07-1.78,.71-3,1.37-3.66,1.98-.36-.25-.67-.61-.95-1.07-.28-.46-.42-.96-.42-1.52s.14-1.04,.42-1.45c.28-.41,.62-.76,1.03-1.07,.51-.41,1.63-.86,3.35-1.37,1.73-.51,4.06-.76,7.01-.76,6.04,0,10.74,1.25,14.09,3.73,3.35,2.49,5.03,6.5,5.03,12.04v22.78c-1.47,.25-3.59,.52-6.36,.8-2.77,.28-5.9,.42-9.41,.42-4.06,0-7.33-.36-9.79-1.07s-4.38-1.64-5.75-2.78c-1.37-1.14-2.29-2.42-2.74-3.85-.46-1.42-.68-2.84-.68-4.27,0-1.83,.28-3.49,.84-4.99s1.51-2.78,2.86-3.85c1.35-1.07,3.16-1.9,5.45-2.52,2.29-.61,5.15-.91,8.61-.91,1.12,0,2.29,.04,3.5,.11,1.22,.08,2.37,.15,3.47,.23,1.09,.08,2.08,.17,2.97,.27,.89,.1,1.59,.18,2.1,.23v-.46c0-2.34-.39-4.27-1.18-5.79-.79-1.52-1.83-2.73-3.12-3.62-1.29-.89-2.78-1.5-4.46-1.83-1.68-.33-3.43-.5-5.26-.5Zm14.02,16.46c-.46-.1-1.66-.3-3.62-.61-1.96-.3-4.84-.46-8.65-.46-1.88,0-3.58,.13-5.1,.38-1.52,.26-2.83,.7-3.92,1.33-1.09,.64-1.93,1.49-2.51,2.55-.58,1.07-.88,2.39-.88,3.96,0,2.74,1.08,4.76,3.24,6.06,2.16,1.29,5.75,1.94,10.78,1.94,3.3,0,5.76-.14,7.39-.42,1.62-.28,2.72-.5,3.28-.65v-14.09Z",
    style: {
      fill: "#010101",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.43,99.81c69.21-17.45,141.21-27.37,212.6-21.3,8.77,.91,21.78,2.42,30.4,3.91-80.35-7.95-164.02,2.85-242.99,17.4h0Z",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "72.03 6.89 72.03 6.88 72.4 6.83 72.57 0 66.93 3.17 64.79 8.1 72.03 6.89",
    style: {
      fill: "#fed208"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.89 6.61 73.82 7.6 77.45 19.76 88.26 11.29 84.89 6.61",
    style: {
      fill: "#fed208"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.28 36.22 30.03 62.52 39.22 36.9 18.28 36.22",
    style: {
      fill: "#fed208"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.76 77.07 86.02 52.71 72.77 7.58 64.79 8.91 69.81 74.74 74.76 77.07",
    style: {
      fill: "#fed208"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.93 76.37 71.27 94.08 74.31 78.68 74.37 78.46 69.93 76.37",
    style: {
      fill: "#fed208"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.96 37.95 65.74 34.73 50.82 66.18 68.64 74.16 65.96 37.95",
    style: {
      fill: "#fed208"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.79 33.41 40.44 36.88 39.34 39.94 36.86 46.86 36.86 46.86 35.7 50.08 30.74 63.91 47.27 65.42 47.27 65.42 49.46 65.72 64.79 33.41",
    style: {
      fill: "#fed208"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 50.34 8.74 49.68 8.99 56.66 9.39 55.56 16.16 36.98 0 50.34",
    style: {
      fill: "#fed208"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16.81 95.83 13.68 78.37 9.22 59 17.22 37.07 29.15 63.11 16.81 95.83",
    style: {
      fill: "#fed208"
    }
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(0 142.88)",
    style: {
      fill: "#231f20",
      fontFamily: "CoHeadline-Light, &apos",
      fontSize: "36.13px",
      fontWeight: 300
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Manu")), /*#__PURE__*/React.createElement("tspan", {
    x: 94.66,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "f"), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 106,
    y: 0
  }, "ac")), /*#__PURE__*/React.createElement("tspan", {
    x: 143.51,
    y: 0,
    style: {
      letterSpacing: "-.02em"
    }
  }, "t"), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 155.97,
    y: 0
  }, "uring ")), /*#__PURE__*/React.createElement("tspan", {
    x: 251.53,
    y: 0,
    style: {
      letterSpacing: "-.02em"
    }
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 274.91,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "ui"), /*#__PURE__*/React.createElement("tspan", {
    x: 303.41,
    y: 0,
    style: {
      letterSpacing: "-.02em"
    }
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 315.7,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "e")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlpacaMs);
export default __webpack_public_path__ + "static/media/AlpacaMS.d5e66ff9a5a24e7661c80a469148bd30.svg";
export { ForwardRef as ReactComponent };